"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactScroll = _interopRequireDefault(require("react-scroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Link = _reactScroll.default.Link;

var AnchorMenuItem = function AnchorMenuItem(_ref) {
  var anchorTo = _ref.anchorTo,
      children = _ref.children,
      label = _ref.label,
      level = _ref.level,
      offset = _ref.offset,
      selected = _ref.selected,
      selectItem = _ref.selectItem,
      other = _objectWithoutProperties(_ref, ["anchorTo", "children", "label", "level", "offset", "selected", "selectItem"]);

  var setSelectedItem = function setSelectedItem() {
    selectItem(anchorTo);
  };

  var linkClasses = (0, _classnames.default)({
    'vn-anchor-menu__item-link': true,
    'vn-anchor-menu__item-link--selected': selected
  });
  var linkStyle = {
    paddingLeft: "".concat(level === 0 ? 0 : level * 25, "px")
  };
  return _react.default.createElement("li", _extends({}, other, {
    className: "vn-anchor-menu__item"
  }), _react.default.createElement(Link, {
    className: linkClasses,
    to: anchorTo,
    spy: true,
    smooth: true,
    duration: 500,
    tabIndex: 0,
    style: linkStyle,
    onClick: setSelectedItem,
    onSetActive: setSelectedItem,
    offset: offset
  }, label), children && _react.default.createElement("ul", null, _react.default.Children.toArray(children).map(function (item) {
    return _react.default.createElement(AnchorMenuItem, _extends({}, item.props, {
      key: item.props.anchorTo,
      level: level + 1,
      selectItem: selectItem
    }), item.props.children);
  })));
};

AnchorMenuItem.propTypes = {
  children: _propTypes.default.node,
  label: _propTypes.default.string.isRequired,
  level: _propTypes.default.number,
  selected: _propTypes.default.bool,
  anchorTo: _propTypes.default.string.isRequired,
  selectItem: _propTypes.default.func,
  offset: _propTypes.default.number
};
AnchorMenuItem.defaultProps = {
  children: null,
  level: 0,
  selected: false,
  selectItem: undefined,
  offset: 0
};
AnchorMenuItem.displayName = 'AnchorMenuItem';
var _default = AnchorMenuItem;
exports.default = _default;